module.exports = __webpack_public_path__ + "static/media/water_500_detail_02.8745752c.jpg";